class Carousel extends HTMLElement {
  constructor() {
    super();
    this.carouselElement = this;

    this.desktopPerPage = this.carouselElement.dataset['desktopperpage'] || 4;
    this.tabletPerPage = this.carouselElement.dataset['tabletperpage'] || 4;
    this.mobilePerPage = this.carouselElement.dataset['mobileperpage'] || 1;
    this.focus = this.carouselElement.dataset['focus'];
    this.type = this.carouselElement.dataset['type'] || 'loop';
    this.gap = this.carouselElement.dataset['gapbetweenslides'] || '20px';
    this.gapMobile = this.carouselElement.dataset['gapbetweenslidesonmobile'] || '10px';
    this.autoplaySpeed = parseInt(this.dataset['autoplaySpeed']) || 3000;
    this.direction = this.carouselElement.dataset['direction'] || 'ltr';
    this.mobilePaddingLeft = this.carouselElement.dataset['mobilepaddingleft'] || '0';
    this.mobilePaddingRight = this.carouselElement.dataset['mobilepaddingright'] || '0';
    this.desktopPaddingLeft = this.carouselElement.dataset['desktoppaddingleft'] || '0';
    this.desktopPaddingRight = this.carouselElement.dataset['desktoppaddingright'] || '0';
    this.slideType = this.carouselElement.dataset['slideType'] || 'loop';
    this.perMoveMobile = this.carouselElement.dataset['mobilePerMove'] || 1;
    this.perMoveDesktop = this.carouselElement.dataset['desktopPerMove'] || 1;

    // Data attribute string matching for correct boolean value
    this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
    this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
    this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
    this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
    this.showdotsonmobile = this.carouselElement.dataset['showdotsonmobile'] === 'true' || false;
    this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
    this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;
    this.destroyOnMobile = this.carouselElement.dataset['enableonmobile'] == 'false' || false;
    this.destroyOnDesktop = this.carouselElement.dataset['enableondesktop'] == 'false' || false;
    this.omitEnd = this.carouselElement.dataset['omitEnd'] == 'false' || false;
    
    this.refresh = this.carouselElement.dataset['refresh'] == 'true' || false;
    this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;

    // Carousel element should have class splide
    if (!this.carouselElement.classList.contains('splide')) return;

    this.initCarousel();
  }

  initCarousel() {
    this.carousel = new Splide(this.carouselElement, {
      perPage: this.desktopPerPage,
      ...(this.type ? { type: this.type } : {}),
      ...(this.focus ? { focus: this.focus } : {}),
      autoplay: this.autoplay,
      interval: this.autoplaySpeed,
      gap: this.gap,
      arrows: this.showarrows,
      pagination: this.showdots,
      isNavigation: this.isNavigation,
      drag: !this.disableDrag,
      direction: this.direction,
      destroy: this.destroyOnDesktop,
      padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
      omitEnd : this.omitEnd,
      type: this.type,
      perMove: this.perMoveDesktop,
      breakpoints: {
        750: {
          padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
          perPage: this.mobilePerPage,
          arrows: this.showarrowsonmobile,
          pagination: this.showdotsonmobile,
          gap: this.gapMobile,
          destroy: this.destroyOnMobile,
          perMove: this.perMoveMobile,
        }
      },
    });

    if (this.sync) {
      this.initCarouselSync();
    } else {
      this.carousel.mount();

      // Only attach video pause logic to the product media carousel
      if (this.carouselElement.classList.contains('product-media-carousel')) {
        this.carousel.on('moved', () => {
          this.carouselElement.querySelectorAll('video').forEach(function(video) {
            if (!video.paused) video.pause();
          });
          this.carouselElement.querySelectorAll('video-player').forEach(function(playerEl) {
            if (playerEl.player && typeof playerEl.player.pause === 'function') {
              playerEl.player.pause();
            }
          });
        });
      }
    }
  }

  // initCarouselSync() {
  //   const syncElement = document.querySelector(this.sync);
  //   const syncDataset = syncElement.dataset;

  //   this.carouselSync = new Splide(this.sync, {
  //     updateOnMove: true,
  //     direction: syncDataset['direction'] || "ttb",
  //     heightRatio: 0.3,
  //     perPage: syncDataset['desktopperpage'] || 5,
  //     type: syncDataset['type'] || 'loop',
  //     focus: syncDataset['focus'] || 'left',
  //     isNavigation: syncDataset['isnavigation'] === 'true' || false,
  //     pagination: false,
  //     arrows: syncDataset['showarrows'] === 'true' || false,
  //     breakpoints: {
  //       750: {
  //         direction: 'ltr',
  //         perPage: syncDataset['mobileperpage'] || 4,
  //         gap: syncDataset['mobilegap'],
  //         pagination: false,
  //       },
  //     },
  //   });

  //   this.carousel.sync(this.carouselSync);
  //   this.carousel.mount();

  //   // Only attach video pause logic to the product media carousel
  //   if (this.carouselElement.classList.contains('product-media-carousel')) {
  //     this.carousel.on('moved', () => {
  //       this.carouselElement.querySelectorAll('video').forEach(function(video) {
  //         if (!video.paused) video.pause();
  //       });
  //       this.carouselElement.querySelectorAll('video-player').forEach(function(playerEl) {
  //         if (playerEl.player && typeof playerEl.player.pause === 'function') {
  //           playerEl.player.pause();
  //         }
  //       });
  //     });
  //   }

  //   this.carouselSync.mount();
  // }

  initCarouselSync() {
  const syncElement = document.querySelector(this.sync);
  if (!syncElement) return;

  const syncDataset = syncElement.dataset;
  const disableSyncDrag = syncDataset['disabledrag'] === 'true';

  this.carouselSync = new Splide(this.sync, {
    updateOnMove: true,
    direction: syncDataset['direction'] || 'ttb',
    heightRatio: 0.3,
    perPage: syncDataset['desktopperpage'] || 5,
    type: syncDataset['type'] || 'loop',
    focus: syncDataset['focus'] || 'left',
    isNavigation: syncDataset['isnavigation'] === 'true',
    pagination: false,
    arrows: syncDataset['showarrows'] === 'true',
    drag: !disableSyncDrag,
    swipe: !disableSyncDrag,
    breakpoints: {
      750: {
        direction: 'ltr',
        perPage: syncDataset['mobileperpage'] || 4,
        gap: syncDataset['mobilegap'],
        pagination: false,
      },
    },
  });

  this.carousel.sync(this.carouselSync);
  this.carousel.mount();
  this.carouselSync.mount();

  // Pause videos on main slide change
  if (this.carouselElement.classList.contains('product-media-carousel')) {
    this.carousel.on('moved', () => {
      this.carouselElement.querySelectorAll('video').forEach(video => {
        if (!video.paused) video.pause();
      });
      this.carouselElement.querySelectorAll('video-player').forEach(playerEl => {
        if (playerEl.player?.pause) {
          playerEl.player.pause();
        }
      });
    });
  }
}

  refreshSlider() {
    this.carousel.refresh();
    if (this.carouselSync) {
      this.carouselSync.refresh();
    }
  }
}

customElements.define('carousel-component', Carousel);
